import type { InputProps } from '../../../ui/input';
import type { IconName } from '../../icons';

import { cn } from '@polyseme/utils/cn/cn-utils';
import { forwardRef } from 'react';

import { Input } from '../../../ui/input';
import { Icon } from '../../icons';

export type TextInputProps = InputProps & {
  leftIcon?: IconName;
  onRightIconClick?: () => void;
  rightIcon?: IconName;
  rightIconClassName?: string;
  wrapperClassname?: string;
};

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      className,
      leftIcon,
      onRightIconClick,
      rightIcon,
      rightIconClassName,
      wrapperClassname,
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn('relative w-full items-center', wrapperClassname)}>
        {!!leftIcon && (
          <Icon
            className="absolute left-0 top-0 m-2.5 size-5 text-muted-foreground"
            name={leftIcon}
          />
        )}
        <Input
          ref={ref}
          className={cn(
            'invalid:border-destructive',
            {
              'pl-9': !!leftIcon,
              'pr-9': !!rightIcon,
            },
            className
          )}
          {...props}
        />
        {!!rightIcon && (
          <Icon
            className={cn(
              'absolute right-0 top-0 m-2.5 size-5 text-muted-foreground',
              { 'cursor-pointer': !!onRightIconClick },
              rightIconClassName
            )}
            name={rightIcon}
            onClick={onRightIconClick}
          />
        )}
      </div>
    );
  }
);

TextInput.displayName = 'TextInput';
